import { useNavigationContext } from '../../../contexts/NavigationContext';
import ProjectPage from './Project/ProjectPage';
import NewsPage from './News/NewsPage';
import MainProjectPage from './MainProjects/MainProjectPage';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout scope={'chiennoir'} websiteLabel={"chien-noir.fr"}>
      <MainProjectPage isActive={navigationContext.activeAppKey === 'cngprojecthighlight'} />
      <ProjectPage isActive={navigationContext.activeAppKey === 'cngproject'} />
      <NewsPage isActive={navigationContext.activeAppKey === 'cngnews'} />
    </MainLayout>
  );
}

export default Home;
